import type { TModernColors } from '@modern/theme/modern-theme.types';

export const darkColors: TModernColors = {
  accent: {
    base: '#ff3d6e',
    border: 'rgba(255, 61, 110, 0.32)',
    deep: '#c51e42',
    deepHover: '#d92352',
    hover: '#ff5885',
    tint: 'rgba(255, 61, 110, 0.1)',
    tintStrong: 'rgba(255, 61, 110, 0.16)',
  },
  border: {
    hairline: 'rgba(255, 255, 255, 0.055)',
    strong: 'rgba(255, 255, 255, 0.34)',
    subtle: 'rgba(255, 255, 255, 0.12)',
  },
  overlay: {
    hover: 'rgba(255, 255, 255, 0.05)',
    hoverStrong: 'rgba(255, 255, 255, 0.08)',
    hoverSubtle: 'rgba(255, 255, 255, 0.03)',
    scrim: 'rgba(4, 6, 10, 0.68)',
    selected: 'rgba(255, 255, 255, 0.06)',
  },
  scrollbar: {
    thumb: '#2a3442',
    thumbHover: '#3a4657',
  },
  status: {
    error: {
      base: '#f0555b',
      border: 'rgba(240, 85, 91, 0.32)',
      tint: 'rgba(240, 85, 91, 0.11)',
    },
    neutral: {
      base: '#586273',
      border: 'rgba(255, 255, 255, 0.12)',
      tint: 'rgba(255, 255, 255, 0.05)',
    },
    ok: {
      base: '#35c97a',
      border: 'rgba(53, 201, 122, 0.3)',
      tint: 'rgba(53, 201, 122, 0.11)',
    },
    sync: {
      base: '#4c9bff',
      border: 'rgba(76, 155, 255, 0.28)',
      tint: 'rgba(76, 155, 255, 0.13)',
    },
    warning: {
      base: '#e8b33e',
      border: 'rgba(232, 179, 62, 0.32)',
      tint: 'rgba(232, 179, 62, 0.11)',
    },
  },
  surface: {
    base: '#0b0e14',
    canvas: '#07090e',
    elevated: '#181d26',
    raised: '#11151c',
    track: '#2f3b4c',
  },
  text: {
    onAccent: '#ffffff',
    primary: '#e7eaf1',
    secondary: '#96a0b2',
    tertiary: '#7e8a9e',
  },
};
